import { LeagueMembershipModel } from "@/models/LeagueMembershipModels";
import { LeagueMembershipsRepo } from "@/repos/LeagueMembershipsRepo";

// src/services/LeagueMembershipService.ts
export class LeagueMembershipService {
    constructor(private leagueMembershipsRepo: LeagueMembershipsRepo) { }

    async listAll(): Promise<LeagueMembershipModel[]> {
        return await this.leagueMembershipsRepo.listAll();
    }

    async get(id: string): Promise<LeagueMembershipModel | null> {
        return await this.leagueMembershipsRepo.getById(id);
    }

    async create(item: LeagueMembershipModel): Promise<void> {
        return await this.leagueMembershipsRepo.create(item, item.encodedEmail);
    }

    async update(id: string, updates: Partial<LeagueMembershipModel>): Promise<void> {
        return await this.leagueMembershipsRepo.update(id, updates);
    }

    async delete(id: string): Promise<void> {
        return await this.leagueMembershipsRepo.delete(id);
    }
}